import LineItemsPreview from './line-items-preview';

export default LineItemsPreview;